// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__g6Kur","actionsCol":"EnrolledClinics_actionsCol__1jvVW"};